export const switchUserRouter = [
  {
    path: `/switch`,
    name: `switch`,
    redirect: `/switch/user`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/switch/user',
        name: '/switch/user',
        component: () => import('@/views/switchUser/SwitchUser')
      }
    ]
  }
];
